import _config from './config.json';

type Config = Omit<typeof _config, 'isE2E' | 'videoPagerMaxPreloadInDev'> & {
  isProd: boolean;
  isE2E: boolean;
  videoPagerMaxPreloadInDev: number;
};

const config = _config as unknown as Config;

config.isProd = config.env === 'prod';
config.isE2E = _config.isE2E === 'true';
config.videoPagerMaxPreloadInDev = Number(_config.videoPagerMaxPreloadInDev);

export function IS_PROD() {
  return config.isProd;
}

export function stripePublishableKey(): string {
  return config.stripeKey;
}

export { config };
